import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    text: String,
  };

  async copy() {
    const text = this.textValue || window.location.href;
    try {
      await navigator.clipboard.writeText(text);
      this.flash("Link copied");
    } catch (error) {
      console.error(`Failed to copy to clipboard: ${error.message}`);
      this.flash("Unable to copy link (your browser may not support this)");
    }
  }

  flash(message) {
    const event = new CustomEvent("reseepe:toast", { detail: { message } });
    window.dispatchEvent(event);
  }
}
